// ========================================
// ================== V3 ==================
// ========================================

import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";

const initialState = {
  plans: null,
  plans_error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.V3_PLANS_SET:
      return fetchPlansSet(state, action);
    case aTypes.V3_PLANS_FETCH_FAIL:
      return fetchPlansSetFail(state, action);
    default:
      return state;
  }
};

const fetchPlansSet = (state, action) => {
  return updateObject(state, {
    plans: action.data,
  });
};

const fetchPlansSetFail = (state, action) => {
  return updateObject(state, {
    plans_error: action.error,
  });
};

export default reducer;
